





















































































































































































import Vue from "vue";
import { isNil } from "ramda";
import Header from "@/components/Header.vue";
import { RequestService } from "@/services";
import config from "@/services/config";

const requestService = new RequestService();
const handleResponse = (response: Response) => {
  if (!response.ok) {
    // TODO handle errori
  } else {
    return response.json();
  }
};

export default Vue.extend({
  props: ['user'],
  components: {
    Header
  },
  data: function() {
    return {
      loggedUser: this.$props.user,
      modalTitle: '',
      showCTA: false,
      config,
    };
  },
  methods: {
    nuovoProdotto: function() {
      const vm = this as any;
      return vm.isAdmin() || vm.hasCategoryRole('nuovo-prodotto');
    },
    dashboardVitaInvestimento: function() {
      const vm = this as any;
      if (!vm.hasCategoryRole('vita-investimento') && !vm.isAdmin() || vm.noDashboard()) { return; }
      vm.$router.push({ name: 'dashboard-vita-investimento', params: {user: vm.loggedUser}});
    },
    dashboardDanniNonAuto: function() {
      const vm = this as any;
      if (!vm.hasCategoryRole('danni-non-auto') && !vm.isAdmin() || vm.noDashboard()) { return; }
      vm.$router.push({ name: 'dashboard-danni-non-auto', params: {user: vm.loggedUser}});
    },
    dashboardProtezionePersona: function() {
      const vm = this as any;
      if (!vm.hasCategoryRole('protezione-persona') && !vm.isAdmin() || vm.noDashboard()) { return; }
      vm.$router.push({ name: 'dashboard-protezione-persona', params: {user: vm.loggedUser}});
    },
    databaseProtezioneInvestimento: function(customCategory: string, customLabel: string) {
      const vm = this as any;
      if (!vm.hasCategoryRole('vita-investimento') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'database-protezione-investimento', params: {user: vm.loggedUser, customCategory: customCategory, customLabel: customLabel}});
    },
    databaseProtezioneImprese: function() {
      const vm = this as any;
      if (!vm.hasCategoryRole('vita-protezione') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'database-protezione-imprese', params: {user: vm.loggedUser}});
    },
    databaseProtezionePatrimonio: function() {
      const vm = this as any;
      if (!vm.hasCategoryRole('danni-auto') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'database-protezione-patrimonio', params: {user: vm.loggedUser}});
    },
    databaseProtezionePersona: function(customCategory: string, customLabel: string) {
      const vm = this as any;
      if (!vm.hasCategoryRole('danni-non-auto') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'database-protezione-persona', params: {user: vm.loggedUser, customCategory: customCategory, customLabel: customLabel}});
    },
    databaseProtezioneCredito: function(customCategory: string, customLabel: string) {
      const vm = this as any;
      if (!vm.hasCategoryRole('cpi-ppi') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'database-protezione-credito', params: {user: vm.loggedUser, customCategory: customCategory, customLabel: customLabel}});
    },
    protezioneInvestimento: function(customCategory: string, customLabel: string) {
      const vm = this as any;
      if (!vm.hasCategoryRole('vita-investimento') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'protezione-investimento', params: {user: vm.loggedUser, customCategory: customCategory, customLabel: customLabel}});
    },
    protezioneImprese: function() {
      const vm = this as any;
      if (!vm.hasCategoryRole('vita-protezione') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'protezione-imprese', params: {user: vm.loggedUser}});
    },
    protezionePatrimonio: function() {
      const vm = this as any;
      if (!vm.hasCategoryRole('danni-auto') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'protezione-patrimonio', params: {user: vm.loggedUser}});
    },
    protezionePersona: function(customCategory: string, customLabel: string) {
      const vm = this as any;
      if (!vm.hasCategoryRole('danni-non-auto') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'protezione-persona', params: {user: vm.loggedUser, customCategory: customCategory, customLabel: customLabel}});
    },
    protezioneCredito: function(customCategory: string, customLabel: string) {
      const vm = this as any;
      if (!vm.hasCategoryRole('cpi-ppi') && !vm.isAdmin()) { return; }
      vm.$router.push({ name: 'protezione-credito', params: {user: vm.loggedUser, customCategory: customCategory, customLabel: customLabel}});
    },
    getUser: async function() {
      const vm = this as any;
      const serviceCallReturnValue = await requestService.getUser()
        .then(handleResponse)
        .then((result: any) => {
          vm.loggedUser = result;
        });
    },
    isAdmin: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('admin') >= 0 || vm.loggedUser.roles.indexOf('admin-view') >= 0;
      }
      return false;
    },
    isAdvanced: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('advanced') >= 0 || vm.isAdmin();
      }
      return false;
    },
    noDashboard: function() {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf('no-dashboard') >= 0;
      }
      return false;
    },
    hasCategoryRole: function(category: string) {
      const vm = this as any;
      if (vm.loggedUser && vm.loggedUser.roles) {
        return vm.loggedUser.roles.indexOf(category) >= 0 || vm.isAdmin();
      }
      return false;
    },
    openModal(title: string) {
      const vm = this as any;
      vm.modalTitle = title;
      vm.$bvModal.show("modal-cambio-password");
    },
    closeModal() {
      const vm = this as any;
      vm.$bvModal.hide("modal-cambio-password");
      vm.$router.push({ name: 'cambio-password', params: {user: vm.loggedUser, homeRoute: 'home-prodotti'}});
    },
    onClickModal() {
      const vm = this as any;
      vm.closeModal();
    },
  },
  created() {
    const vm = this as any;
    if (vm.$props.user == undefined) {
      vm.getUser();
    }
  },
  mounted() {
    const vm = this as any;
    if (vm.loggedUser) {
      if (vm.loggedUser.passwordForgotten) {
        vm.openModal('Password dimenticata');
      } else if (vm.loggedUser.firstAccess || vm.loggedUser.passwordExpired) {
        vm.openModal(vm.loggedUser.firstAccess ? 'Password di primo accesso' : 'Password scaduta');
      }
    }
  }
});
